export default __webpack_public_path__ + "static/media/logistique.e06cb99d.png";